
const [w,d,l] = [window,document,location]

export default function FEATURES () {

  const init = () =>{

    $(document).on('click','.accordion-btn', function(){
      $(this).toggleClass('open-ac');
      $(this).prev('.accordion-body').toggleClass('open-ac');
    });
  }

  w.addEventListener('DOMContentLoaded',init)

}